import template from './ecocode-trustpilot-configure.html.twig';
import './ecocode-trustpilot-configure.scss';

const { Mixin, Component } = Shopware;

Component.register('ecocode-trustpilot-configure', {
    template,
    emits:['frw-set-title','buttons-update', 'frw-redirect', 'modal-close'],
    inject: ['ecocodeTrustpilotConfigurationService'],
    mixins: [
        Mixin.getByName('notification')
    ],
    async mounted() {
        this.isLoading = true;
        const status = await this.ecocodeTrustpilotConfigurationService.status();

        if (!status.isConnected) {
            this.$router.push({ name: 'ecocode.trustpilot.setup.welcome' });
        }
        this.isLoading = false;
    },
    created() {
        this.createdComponent();
    },
    methods: {
        createdComponent() {
            this.setTitle();
            this.updateButtons();
        },
        updateButtons() {
            const buttonConfig = [
                {
                    key: 'disconnect',
                    label: this.$tc('ecocode-trustpilot.general.buttonDisconnect'),
                    position: 'left',
                    variant: null,
                    action: this.onDisconnect.bind(this),
                    disabled: false
                },
                {
                    key: 'cancel',
                    label: this.$tc('ecocode-trustpilot.general.buttonCancel'),
                    position: 'right',
                    variant: null,
                    action: this.onCancel.bind(this),
                    disabled: false
                },
                {
                    key: 'next',
                    label: this.$tc('sw-first-run-wizard.general.buttonNext'),
                    position: 'right',
                    variant: 'primary',
                    action: this.onSave.bind(this),
                    disabled: this.isLoading
                }
            ];

            this.$emit('buttons-update', buttonConfig);
        },
        onCancel() {
            this.$emit('modal-close');
        },
        setTitle() {
            this.$emit('frw-set-title', this.$tc('ecocode-trustpilot.configure.modalTitle'));
        },
        async onDisconnect() {
            await this.ecocodeTrustpilotConfigurationService.disconnect();
            this.$emit('frw-redirect', 'ecocode.trustpilot.setup.connect');
        },
        onSave() {
            this.$refs.trustpilotConfig.save().then(() => {
                this.isLoading = false;
                this.$emit('frw-redirect', 'ecocode.trustpilot.setup.invitation');
                this.createNotificationSuccess({
                    message: this.$tc('ecocode-trustpilot.configure.messageSaveSuccess')
                });
            }).catch((err) => {
                this.isLoading = false;
                this.createNotificationError({
                    message: err
                });
            });
        }
    }
});
